import NextImg from "next/image";
import Link from "next/link";
import styled from "styled-components";
import Container from "../../../shared/Container";
// import HeroTitle from "./HeroTitle";
import HeroRightImg from "/public/imagess/hero-right.png";

const HeroSection = () => {
  return (
    <div className="bg-[#EBF3FD] md:bg-white">
      <Hero className="pt-10 md:pt-6">
        <Container>
          <div className="grid md:grid-cols-2 md:gap-12 items-center ">
            <div className="relative"  style={{width:"max-content"}}>
              <h1 className="text-6xl md:text-7xl font-bold text-main">
                <span className="inline-block relative">
                  <span className="relative">Employ</span>
                  <br />
                  <span className="block absolute -right-[6rem] mt-6">Twin</span>
                </span>
              </h1>

              <p className="text-3xl md:text-xl font-medium text-black mt-[100px] pt-6 mb-14 text-center md:text-start">
                <span>Simply consistent.</span> <span className=" md:mt-4 block sm:inline">Surprisingly creative.</span>
              </p>

               <div
                className="w-11/12 md:w-auto flex flex-col gap-6 mt-6 md:mt-0"
                style={{
                  marginLeft: "20px",
                  marginRight: "20px",
                }}
              >
                <Link href={"/checkout/all?origin=home"} className="">
                  <a className="md:py-3 px-6 text-center inline-block min-w-full md:min-w-full twinBots text-lg  md:text-s font-medium text-dark border-2 border-main rounded-full  duration-500 hover:bg-main hover:text-white cursor-pointer">
                    Hire your Employee Twin now!
                  </a>
                </Link>
                <Link href={"/export-employeetwin"} className="">
                  <a className="md:py-3 px-6 text-center inline-block min-w-full md:min-w-full text-lg  md:text-s font-medium text-[#00a888] border-2 border-[#00a888] rounded-full  duration-500 hover:bg-[#00a888] hover:text-white cursor-pointer">
                    Export Employee Twins
                  </a>
                </Link>
              </div>             

            </div>
            <div className="relative">
              <figure className="">
                <NextImg src={HeroRightImg} placeholder="blur" alt="employee twin" />
              </figure>
            </div>
          </div>
        </Container>
      </Hero>
    </div>
  );
};

export default HeroSection;

const Hero = styled.div`
  @media (min-width: 640px) {
    background: url("/imagess/hero-bg.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  h1 {
    span > span:first-of-type {
      &::after {
        content: "";
        background-image: url("/imagess/ee.svg");
        background-size: contain;
        position: absolute;
        z-index: 1;
        height: 100%;
        width: 100%;
        background-repeat: no-repeat;
      }
    }
  }
`;
